import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { RxCross1 } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { HttpService } from "../../../service/HttpService";
import { useAuth } from "../../../context/AuthProvider";

function AddEditUnits({ open, handleClose, clickedUnitId, isAdd, fetchUnits }) {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);

  const validationSchema = Yup.object({
    name: Yup.string().trim().required("Name is required"),
    description: Yup.string().trim().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      // description: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        // const formData = new FormData();
        // formData.append("name", (values?.name || "").trim());
        // formData.append("description", (values?.description || "").trim());

        const payload = {
          name: values.name,
        };

        if (isAdd) {
          const res = await httpService.post("inventory/units", payload);
          if (res) {
            toast.success("Unit Added Successfully", { position: "top-right" });
            formik.resetForm();
            handleClose();
            fetchUnits();
          }
        } else {
          const res = await httpService.put(
            `${"inventory/units"}/${clickedUnitId}`,
            payload
          );
          if (res) {
            toast.success("Unit Updated Successfully", {
              position: "top-right",
            });
            formik.resetForm();
            handleClose();
            fetchUnits();
          }
        }
      } catch (e) {}
    },
  });

  const fetchOne = async (id) => {
    try {
      const res = await httpService.get(`${"inventory/units"}/${id}`);
      const data = res?.data?.data || res?.data || res;
      if (data) {
        formik.setValues({
          name: data?.name || "",
          symbol: data?.symbol || "",
          description: data?.description || "",
        });
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (open && !isAdd && clickedUnitId) {
      fetchOne(clickedUnitId);
    } else if (open && isAdd) {
      formik.resetForm();
    }
  }, [open, isAdd, clickedUnitId]);

  return (
    <>
      <Modal
        className="department-modal"
        open={open}
        onClose={() => {
          formik.resetForm();
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="modal_block">
            <div className="modal_header">
              <div className="modal_title_wrapper">
                <h2 className="modal_title">
                  {isAdd ? "Add Unit" : "Edit Unit"}
                </h2>
              </div>
              <div className="cancel-btn-wrap">
                <RxCross1
                  onClick={() => {
                    formik.resetForm();
                    handleClose();
                  }}
                />
              </div>
            </div>
            <div className="modal_content">
              <div className="row">
                <div className="col-md-6">
                  <div className="form_field_wrapper">
                    <label>
                      Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <TextField
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="e.g. Gram"
                      size="small"
                      fullWidth
                    />
                    {formik.touched.name && formik.errors.name && (
                      <span style={{ color: "red" }}>{formik.errors.name}</span>
                    )}
                  </div>
                </div>

                {/* <div className="col-md-12">
                  <div className="form_field_wrapper">
                    <label>Description</label>
                    <TextField
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Optional"
                      size="small"
                      fullWidth
                      multiline
                      minRows={3}
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <div className="modal_footer">
              <button
                type="button"
                onClick={() => {
                  formik.resetForm();
                  handleClose();
                }}
                className="btn btn-border"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                {isAdd ? "Save" : "Update"}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default AddEditUnits;
